export const data = [
    {
      question: "الفواكه المجففة",
      option1: "صحي",
      option2: "غير صحي",
      ans: 2,
    },
    {
      question: "التفاح",
      option1: "صحي",
      option2: "غير صحي",
      ans: 1,
    },
    {
      question: "الليمون",
      option1: "صحي",
      option2: "غير صحي",
      ans: 2,
    },
    {
      question: "الجزر",
      option1: "صحي",
      option2: "غير صحي",
      ans: 1,
    },
    {
      question: "المخبوزات (العيش)",
      option1: "صحي",
      option2: "غير صحي",
      ans: 2,
    },
    {
      question: "الشيبسي",
      option1: "صحي",
      option2: "غير صحي",
      ans: 2,
    },
    {
      question: "الجبنة البيضاء",
      option1: "صحي",
      option2: "غير صحي",
      ans: 1,
    },
    {
      question: " الكيوي",
      option1: "صحي",
      option2: "غير صحي",
      ans: 1,
    },
  
    {
      question: "سمك",
      option1: "صحي",
      option2: "غير صحي",
      ans: 1,
    },
  ];